import Api from './config';

class CoherentApi {
    static async createPaymentLink(data) {
        return Api.request({
            method: 'POST',
            url: '/coherence/create-payment-link',
            data
        });
    }

    static async checkPayment(transactionId) {
        return Api.request({
            method: 'GET',
            url: `/coherence/check-payment/${transactionId}`
        });
    }

    static async getTerminals(clinicId = null, key = null) {
        const params = new URLSearchParams();
        if (clinicId) params.append('clinicId', clinicId);
        if (key) params.append('key', key);

        const queryString = params.toString();
        return Api.request({
            method: 'GET',
            url: `/coherence/terminals${queryString ? `?${queryString}` : ''}`
        });
    }

    static async getSavedCards(customerId, clinicId = null) {
        const params = clinicId ? `?clinicId=${clinicId}` : '';
        return Api.request({
            method: 'GET',
            url: `/coherence/saved-cards/${customerId}${params}`
        });
    }

    static async createSavedCard(data) {
        return Api.request({
            method: 'POST',
            url: '/coherence/saved-card',
            data
        });
    }

    static async setDefaultSavedCard(data) {
        return Api.request({
            method: 'PUT',
            url: '/coherence/saved-card/default',
            data
        });
    }

    static async deleteSavedCard(walletUuid, customerId, clinicId = null) {
        const params = clinicId ? `?customerId=${customerId}&clinicId=${clinicId}` : `?customerId=${customerId}`;
        return Api.request({
            method: 'DELETE',
            url: `/coherence/saved-card/${walletUuid}${params}`
        });
    }
}

export default CoherentApi;
